module.exports = __webpack_public_path__ + "static/media/iconLatLng.644c5d8e.svg";